import { crossDomainLinker } from '@snowplow/browser-tracker';

import type { CrossDomainLinkerCriterion } from './cross-domain-linker-criterion';
import { linksToHcDomainCriterion } from './cross-domain-linker-criterion';

interface ApplyCrossDomainLinker {
  crossDomainLinkerCriterion?: CrossDomainLinkerCriterion;
}

/**
 * Apply cross-domain linker, including cross-domain tracking, for links that were
 * added after the page has loaded.
 *
 * v.0.12.0;
 * @public
 *
 * @param config - Configuration which includes:
 * - crossDomainLinkerCriterion: Optional function that receives an
 *   HTMLAnchorElement or HTMLAreaElement that's been clicked and returns
 *   true/false depending on whether the navigation performed by that click
 *   should include the Snowplow cross-domain tracking parameters.
 *
 * @example
 * ```ts
 * import { applyCrossDomainLinker } from '@hc-frontend/third-party-snowplow';
 *
 * applyCrossDomainLinker({});
 * ```
 */
function applyCrossDomainLinker({
  crossDomainLinkerCriterion = linksToHcDomainCriterion,
}: ApplyCrossDomainLinker): void {
  crossDomainLinker(crossDomainLinkerCriterion);
}

export { applyCrossDomainLinker };
